import { Component, OnInit, OnDestroy, Output, EventEmitter, ChangeDetectorRef, Input } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Company } from 'src/app/core/interfaces/company';
import { AngularFireStorage } from '@angular/fire/storage';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { Utils } from 'src/app/core/resources/utils';
import { CompaniesService } from 'src/app/modules/administration/companies/list-companies.service';
import { AccountService } from 'src/app/modules/account/account.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { DynamicFirebaseService } from 'src/app/core/services/dynamic-firebase.service';
import { CompanyResource } from 'src/app/core/interfaces/companyResource';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageService } from 'src/app/core/services/storage.service';
import { fromEvent, Subscription } from 'rxjs';
import { CargoService } from 'src/app/core/services/cargo.service';
import { GpsTrackingAlertComponent } from 'src/app/shared/gps-tracking-alert/gps-tracking-alert.component';
import { Notification } from 'src/app/core/interfaces/notification';
import { NotificationsClientService } from 'src/app/notifications/services/notifications-client.service';
import { MessagingService } from 'src/app/notifications/services/messages.services';
// declare var FB: any;

// window['fbAsyncInit'] = () => {
//   FB.init({
//     appId: '203328834846268',
//     autoLogAppEvents: true,
//     xfbml: true,
//     version: 'v10.0'
//   });
// };

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  public environment = environment;
  companyUser: Company;
  businessUser: Company;
  userName: string;
  urlLogoSubcompany: string;
  public primaryLogo: string;
  public secondaryLogo: string;
  calculatedHeight: number | null = null;
  showGpsAlert: boolean = false; // Por defecto no se muestra
  @Input() rndcContingency: boolean = false;
  @Output() gpsAlertVisibilityChange = new EventEmitter<boolean>();
  private gpsAlertSubscription: Subscription;
  notification: Notification;
  public unreadNotifications = 0;
  private notificationsSubscriptions: Subscription[] = [];
  constructor(
    public authService: AuthService,
    public dialog: MatDialog,
    private router: Router,
    private modalService: NgbModal,
    private angularFireStorage: AngularFireStorage,
    public titleService: Title,
    private utils: Utils,
    private companiesService: CompaniesService,
    private accountService: AccountService,
    private companyService: CompanyService,
    public dynamicService: DynamicFirebaseService,
    private spinner: NgxSpinnerService,
    private cargoService: CargoService,
    private cdr: ChangeDetectorRef,
    private notificationsClient: NotificationsClientService,
    private messagingService: MessagingService
  ) { }

  ngOnInit() {
    if (this.authService && this.authService.sessionActive()) {
      const onClick$ = fromEvent(document, 'click').subscribe(() => {
        CargoService.clickMadeToStartSounds = true;
        onClick$.unsubscribe();
      });
      this.companyUser = this.authService.getCompany();
      if (this.authService.getUserSession().information.name)
        this.userName = this.authService.getUserSession().information.name.split(' ')[0];
      if (this.companyUser && this.companyUser.name) {
        this.businessUser = {
          name: this.companyUser.name,
          companyId: this.companyUser.companyId
        };
      }
    }
    this.getCurrentLogo();
    
    // Suscribirse a las alertas GPS
    this.gpsAlertSubscription = this.cargoService.gpsTrackingAlert$.subscribe(notification => {
      setTimeout(() => {
        this.showGpsAlert = notification !== null;
        this.notification = notification;
        this.gpsAlertVisibilityChange.emit(this.showGpsAlert);
        this.cdr.detectChanges();
      }, 0);
    });
    
    // Emitir el estado inicial del alert después de que la vista se inicialice
    setTimeout(() => {
      this.gpsAlertVisibilityChange.emit(this.showGpsAlert);
    }, 0);

    this.subscribeToUnreadNotifications();
  }

  ngOnDestroy() {
    if (this.gpsAlertSubscription) {
      this.gpsAlertSubscription.unsubscribe();
    }
    this.notificationsSubscriptions.forEach(s => s.unsubscribe());
    this.notificationsSubscriptions = [];
  }

  public unreadBadgeLabel(): string {
    if (this.unreadNotifications <= 0) return '';
    if (this.unreadNotifications > 99) return '99+';
    return String(this.unreadNotifications);
  }

  public refreshNotificationsMenu(): void {
    this.notificationsClient.requestNotificationsRefresh();
  }

  private subscribeToUnreadNotifications() {
    if (!this.authService || !this.authService.sessionActive()) return;

    this.notificationsSubscriptions.push(
      this.notificationsClient.unreadCount$.subscribe(count => {
        this.unreadNotifications = count;
        this.cdr.detectChanges();
      }),
      this.messagingService.foregroundMessage$.subscribe(() => {
        this.notificationsClient.refreshUnreadCount();
      })
    );

    this.notificationsClient.refreshUnreadCount();
  }

  openModalConfirmLogOut(modal) {
    this.modalService.open(modal, { keyboard: false, centered: true, ariaLabelledBy: 'modal-basic-title' });
  }

  closeModalConfirmLogOut() {
    this.modalService.dismissAll();
  }

  private async getCurrentLogo() {
    try {
      if (this.authService && this.authService.sessionActive()) {
        //Validate by company's logo
        let companyUserLogo: string;
        if (this.companyUser && this.companyUser.logo) companyUserLogo = await this.getUrlFileStorageLogo(this.companyUser.companyId, this.companyUser.logo);
        if (!companyUserLogo) companyUserLogo = await this.getUrlCompanyResourceLogo(this.companyUser.companyId);
        if (companyUserLogo) {
          if (this.authService.userIsFromRootNit()) {
            this.primaryLogo = companyUserLogo;
            return;
          } else this.secondaryLogo = companyUserLogo;
        }
        //Validate by Holder company's logo
        let holderCompanyLogo: string;
        let holderCompany: Company = this.companyService.holderCompany;
        if (holderCompany && holderCompany.logo && holderCompany.companyId) holderCompanyLogo = await this.getUrlFileStorageLogo(holderCompany.companyId, holderCompany.logo);
        if (!holderCompanyLogo) holderCompanyLogo = await this.getUrlCompanyResourceLogo(StorageService.checkStorage().getItem('_companyId'));
        if (holderCompanyLogo) {
          this.primaryLogo = holderCompanyLogo;
          return;
        }
      }
      //Validate by default
      this.primaryLogo = this.utils.getDefaultUrlLogo('mainLogo');
    } catch (error) {
      console.error(error);
      this.primaryLogo = this.utils.getDefaultUrlLogo('mainLogo');
    }

  }

  async logOut() {
    this.spinner.show();
    const response = await this.authService.attemptLogout();
    this.closeModalConfirmLogOut();
    if (!response) return this.spinner.hide();;
    this.userName = '';
    try {
      await this.dynamicService.deleteAllFirebaseInstances();
    } catch { }
  }

  goHome() {
    this.router.navigate(['/home']);
  }

  async getUrlFileStorageLogo(companyId: string, companyLogo: string) {
    try {
      const path = '/company/' + companyId + '/' + companyLogo;
      const url = await this.getDownloadURL(path);
      return url;
    } catch (error) {
      return null;
    }

  }

  async getUrlCompanyResourceLogo(companyId: string) {
    try {
      const resources: CompanyResource[] = await this.companiesService.getResourcesCompany(companyId).toPromise();
      if (!resources || !resources.length) return null;
      const resource = resources.find(resource => resource.fileType === "logo");
      if (!resource || !resource.path) return null;
      const url = await this.getDownloadURL(resource.path);
      return url;
    } catch (error) {
      return null;
    }
  }

  async getDownloadURL(path) {
    try {
      const storage = AuthService.fStorage;
      const pathReference = storage.ref(path);
      const urlCompanyLogo = await pathReference.getDownloadURL();
      return urlCompanyLogo;
    } catch (error) {
      console.error('error getting storage', error)
      return null;
    }
  }

  onImageLoad(event: Event): void {
    const img = event.target as HTMLImageElement;
    const maxHeight = 72;
    const maxWidth = 160;
    const aspectRatio = img.naturalWidth / img.naturalHeight;
    this.calculatedHeight = aspectRatio > 1 ? Math.min(maxHeight, maxWidth / aspectRatio) : maxHeight;
  }

  onGpsAlertClose() {
    this.showGpsAlert = false;
    this.cargoService.emitGpsTrackingAlert(null);
    this.gpsAlertVisibilityChange.emit(false);
  }
}
